import { Alert, Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function GovernanceHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const cards = [
    {
      path: '/education/governance/policies',
      title: t('governancePolicies'),
      desc: t('governancePoliciesIntro'),
    },
    {
      path: '/education/governance/committees',
      title: t('governanceCommittees'),
      desc: t('governanceCommitteesIntro'),
    },
  ];

  return (
    <EducationPageChrome title={t('governance')} description={t('governanceIntro')}>
      <Alert type="info" showIcon style={{ marginBottom: 16 }} message={t('governanceSeparateHint')} />
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
